import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { AssetsHelper } from '@/helpers/assetsHelper';
import { EEMO_ICON_KEY } from './enums/eemo-icon.enums';

@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ]
})
export class IconEemoModuleModule {

  private EEMO_ICON_PATH = AssetsHelper.eemoIcon;
  private SEND_ICON_PATH = AssetsHelper.sendIcon;

  constructor(iconRegistry: MatIconRegistry, sanitizer: DomSanitizer) {
    iconRegistry.addSvgIcon(EEMO_ICON_KEY.EEMO, sanitizer.bypassSecurityTrustResourceUrl(this.EEMO_ICON_PATH));
    iconRegistry.addSvgIcon(EEMO_ICON_KEY.SEND, sanitizer.bypassSecurityTrustResourceUrl(this.SEND_ICON_PATH));
  }
}
